'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENTRIES = exports.ENTRIES = ['entries'];
var ID_INVARIANT = exports.ID_INVARIANT = ['idInvariant'];
var ID_TRANSFORM = exports.ID_TRANSFORM = ['idTransform'];
var NAME = exports.NAME = ['name'];
var NOT_SET_VALUE = exports.NOT_SET_VALUE = ['notSetValue'];